import {IHostingDomainsState} from "../reducers/hosting-domains.reducer";
import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {HostingDomainsDataMapper} from "../../websites/website/hosting/domains/hosting-domains-mapper";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getDomainsHostingState = createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.hostingDomains);

/*Domain Names*/
export const getDomains = (websiteId: number) => createSelector(getDomainsHostingState,
  (state: IHostingDomainsState) => {
    if (state.entities && state.entities[websiteId]) {
     return Object.values(HostingDomainsDataMapper.map(Object.values(state.entities[websiteId] && state.entities[websiteId].domainEntities), Object.values(state.zoneEntities)));
    }
    else {
      return [];
    }}
);

export const getZonesList = (websiteId: number) => createSelector(getDomainsHostingState,
  (state: IHostingDomainsState) => {
    if (state.entities && state.entities[websiteId]) {
      return state.zoneEntities;
    }
    else {
      return [];
    }}
);

/*Domain Names*/
export const getDomainsCount = (websiteId: number) => createSelector(getDomainsHostingState,
  (state: IHostingDomainsState) => {
    if (state.entities && state.entities[websiteId]) {
      return Object.values(state.entities[websiteId] && state.entities[websiteId].domainEntities).length;
    }
    else {
      return 0;
    }}
);

export const getDomainsMap = (websiteId: number) => createSelector(getDomainsHostingState,
  (state: IHostingDomainsState) =>
    state.entities[websiteId]
);

export const getDomain = (websiteId: number) => createSelector(getDomainsHostingState,
    (state: IHostingDomainsState) =>
      state.entities[websiteId]
);

export const getDomainsLoading = (websiteId: number) => createSelector(getDomainsHostingState,
  (state: IHostingDomainsState) =>
    state.loading || state.entities[websiteId].loading
);

export const getDomainsLoaded = (websiteId: number) => createSelector(getDomainsHostingState,
  (state: IHostingDomainsState) =>
    state.loaded || state.entities[websiteId] ? state.entities[websiteId] && state.entities[websiteId].loaded : false
);
